<div class="carousel-wrapper">
  <div class="highlight-rect"
       *ngIf="highlightedFlat || (selectedPoint && selectedPoint.side === activeSide)"
       [ngStyle]="{'left.px': getHightLightedFlatRectPos(true),
                       'top.px': getHightLightedFlatRectPos(false)}">
  </div>


  <div class="ui popup top left custom-popup"
       [ngStyle]="{'left.px': getHightLightedFlat(true), 'top.px': getHightLightedFlat(false)}"
       *ngIf="highlightedFlat"
       (click)="openFlatPage()">
    <div class="content">
      <div class="flat-name">
        {{highlightedFlat.name}} lakás - {{highlightedFlat.size}} m²
      </div>
      <div class="flat-prize">
        {{removeHuf(highlightedFlat.price | currency : 'HUF' : 'symbol' : '1.0-0')}} Forint
      </div>
      <div class="click-for-details">
        Kattintson a részletekért!
      </div>
    </div>
  </div>
  <ngx-hm-carousel
    [(ngModel)]="index"
    (ngModelChange)="indexChanged($event)"
    [autoplay-speed]="speed"
    [autoplay]="false"
    [autoplay-direction]="direction"
    [infinite]="infinite"
    [between-delay]="2000"
    [mourse-enable]="true"
    [data]="carouselItems"
    [aniTime]="300"
    (click)="carouselClicked($event)"
    *ngIf="imageHeight"
    class="carousel c-accent">

    <section ngx-hm-carousel-container class="content">
      <img class="item"
           (load)="carouselImageLoaded()"
           [class.active-carousel-item]="activeIndex === i"
           [src]="carouselItem.imageUrl" [style.height.px]="imageHeight"
           ngx-hm-carousel-item
           *ngFor="let carouselItem of carouselItems; let i = index;">


      <!--    <div class="item cursor-pointer" [ngStyle]="getCarouselItemBg(carouselItem)"-->
      <!--         ngx-hm-carousel-item-->
      <!--         *ngFor="let carouselItem of carouselItems">-->

      <!--      <div class="text-content">-->

      <!--        <h1>{{carouselItem.title}}</h1>-->
      <!--        <p>{{carouselItem.summary}}</p>-->

      <!--      </div>-->

      <!--      <div class="shape"></div>-->
      <!--    </div>-->
      <ng-template #infiniteContainer></ng-template>
    </section>

    <ng-template #carouselContent let-carouselItem let-i="index">
      <div class="item cursor-pointer" [ngStyle]="getCarouselItemBg(carouselItem)">>
        <!--      <div class="text-content">-->

        <!--        <h1>{{carouselItem.title}}</h1>-->
        <!--        <p>{{carouselItem.description}}</p>-->

        <!--      </div>-->
        <!--            <div class="shape"></div>-->
      </div>
    </ng-template>

    <ng-template #carouselPrev>
      <div class="click-area" [class.selector-mode]="selectorMode">
        <i class="material-icons" [class.loaded]="loaded">keyboard_arrow_left</i>
      </div>
    </ng-template>
    <ng-template #carouselNext>
      <div class="click-area" [class.selector-mode]="selectorMode">
        <i class="material-icons" [class.loaded]="loaded">keyboard_arrow_right</i>
      </div>
    </ng-template>

    <ng-template #carouselDot let-model>
      <div class="square bg-accent"
           [class.visible]="model.index === model.currentIndex"></div>
    </ng-template>

    <ng-template #carouselProgress>
      <div class="progress"></div>
    </ng-template>

  </ngx-hm-carousel>

</div>
